<template>
  <CommonBreadcrumbs :breadcrumbs="breadcrumbsForComponent" :font-size="fontSize" />
</template>

<script setup lang="ts">
import { PagePartsFragmentFragment } from "~/types/pageParts"

type Props = {
  breadcrumbs: PagePartsFragmentFragment["list"]
  fontSize: string[]
}

const props = withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
})

const breadcrumbsForComponent = computed(() =>
  props.breadcrumbs.map((record) => ({
    title: record.title,
    url: record.url,
  })),
)
</script>
